<template>
  <div class="about">
    <div class="container-fluid">
            <div class="row">
                <div class="col-12 gallery-hero d-flex align-items-end">
                    <div class="container">
                        <div class="row">
                            <h1 class="hero-heading">ABOUT</h1>
                        </div>
                    </div>
                    <!-- <Navigation /> -->
                </div>
            </div>
        </div>
        <section class="about pt-100">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 pri-about-title text-center mt-5">
                    <h3 class="heading">“Metropolis” Genesis: Concept of the festival</h3>
                    <hr class="custom-hr">

                </div>
            </div>
            <div class="row mt-5">
                <div class="col-sm-12 text-justify">
                    <p>The quality of being urban transcends beyond bricks and mortar. Urbanity is a test of human skills. It is a quest. It is a quench never satisfying.
                        <b>“METROPOLIS”</b> is a portrayal of this meta-reality. The history of humanity is a story of ceaseless migrations. The phenomenon of migration from rural to urban areas has been continuing since the dawn of history. Since ages, people are migrating to cities in search of a better future. This is the story of all of us. This is the story of urbanity. <b>"METROPOLIS"</b> is the mother city where all cultures meet and flourish, where dreams are weaved and lived, this is the melting pot of opportunities of all kinds; this is where the change begins… <b>"METROPOLIS"</b> as a philosophy is a mindset to adapt, accept and grow, it is about being socially aware and informed and be responsible as an individual and become a collective environment for growth. The city has an ingrained quality of moulding people according to its needs. With the test of time, the continuous struggle for survival and the inevitable rat race associated with it transforms a ‘villager’ to a ‘city dweller’. The “METROPOLIS” teaches us to thrive on, to dream on and most importantly to live on. </p>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-12 text-justify sub-about-title">
                    <h2 class="text-center mb-3">About</h2>
                    <p>There are those who love art, culture, craft, film, music, adventure and ethnicity and there are those who embody it, are driven by it and who lives by the rules of all these. Metropolis is for them. Within a short span of time, Metropolis has become the most awaited event notifying the festive spirit of the city with the overwhelming participation of people in all its annual editions. It is popularly known as one of the warmest urban winter festivals in the Northeastern region.</p>
                    <p>For the last 6 years in a row, Metropolis has been able to garner an immense amount of support and active participation of people not just from the Northeastern corner of India but from across the world. <b> Metropolis: Urban Winter Festival </b> is a three-day Art festival, which is all about bringing together creative ideas, incorporating them in the Festival and collaborating with the creative talents from all across India and beyond.</p>
                    <p>Founded in the year 2013, the festival recognizes and showcases the creativity of young minds in various fields of art, photography, music, craft, literature, film making, gaming, fashion, alternative sports and many more as such. The diverse components of Art that Metropolis caters to in a single platform are indeed a delight to watch as well as to participate. Every theme of the Festival each year besides showcasing a creative pool of talent also provides a rich learning experience through the medium of Art.</p>
                    <p><b>Metropolis Urban Winter Festival</b>,being a reflection of the contemporary reality of quest for human survival and an enabler for promotion of alternative culture and knowledge stands tall towards bringing a global consensus on various important issues. The multi-module structure of the festival allows engagement of different stakeholders, thereby uplifting young talents by way of providing a viable platform for empowerment.</p>
                </div>
            </div>
        </div>    
    </section>
    <!-- <section class="team-section p-100">
        <div class="container">
            <div class="row mt-5">
                <div class="col-12 act-main-title text-center">
                    <h1 class="heading">Our Team</h1><br>
                    <hr class="custom-hr">
                    <span class="mt-5">Meet the amazing team behind Metropolis Asia</span>
                </div>
            </div>
            <div class="row" style="margin-top:90px">
                <div class="col-12 col-md-6 mb-5">
                    <div class="row">
                        <div class="col-4">
                            <div class="team-image">
                                <img src="../assets/images/icon.png" alt="" class="img-fluid">
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="team-detail">
                                <div class="team-name text-uppercase text-info">
                                    <h5>Chombay Kee</h5>
                                </div>
                                <span class="text-muted">Director,MIH</span>
                            </div>
                            <div class="team-social text-center">
                                <ul class="d-flex mt-1 mb-1 text-black p-0 m-0">
                                    <li><a href="#"><i class="fab fa-facebook fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter-square fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram fa-2x"></i></a></li>
                                </ul>
                            </div>
                            <div class="team-detail">
                                <ul>
                                    <li> <strong>Phone:</strong>  +91-9862822777</li>
                                    <li><strong>Email:</strong> chombayz@gmail.com</li>
                                </ul>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mb-5">
                    <div class="row">
                        <div class="col-4">
                            <div class="team-image">
                                <img src="../assets/images/icon.png" alt="" class="img-fluid">
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="team-detail">
                                <div class="team-name text-uppercase text-info">
                                    <h5>Ranjan Engti</h5>
                                </div>
                                <span class="text-muted">Chief Coordinator, MIH</span>
                            </div>
                            <div class="team-social text-center">
                                <ul class="d-flex mt-1 text-black m-0 p-0">
                                    <li><a href="#"><i class="fab fa-facebook fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter-square fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram fa-2x"></i></a></li>
                                </ul>
                            </div>
                            <div class="team-detail">
                                <ul>
                                    <li> <strong>Phone:</strong>  +91-9508788012</li>
                                    <li><strong>Email:</strong> artsofthefrontier@gmail.com</li>
                                </ul>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mb-5">
                    <div class="row">
                        <div class="col-4">
                            <div class="team-image">
                                <img src="../assets/images/icon.png" alt="" class="img-fluid">
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="team-detail">
                                <div class="team-name text-uppercase text-info">
                                    <h5>Silvia Palmei</h5>
                                </div>
                                <span class="text-muted">Chief Advisor, MIH</span>
                            </div>
                            <div class="team-social text-center">
                                <ul class="d-flex mt-1 text-black m-0 p-0">
                                    <li><a href="#"><i class="fab fa-facebook fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter-square fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram fa-2x"></i></a></li>
                                </ul>
                            </div>
                            <div class="team-detail">
                                <ul>
                                    <li> <strong>Phone:</strong>  +91-9717222394</li>
                                    <li><strong>Email:</strong> palmei.g11@fms.edu</li>
                                </ul>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mb-5">
                    <div class="row">
                        <div class="col-4">
                            <div class="team-image">
                                <img src="../assets/images/icon.png" alt="" class="img-fluid">
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="team-detail">
                                <div class="team-name text-uppercase text-info">
                                    <h5>Gautam Bordoloi</h5>
                                </div>
                                <span class="text-muted">Project Head</span>
                            </div>
                            <div class="team-social text-left">
                                <ul class="d-flex mt-1 text-black m-0 p-0">
                                    <li><a href="#"><i class="fab fa-facebook fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter-square fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram fa-2x"></i></a></li>
                                </ul>
                            </div>
                            <div class="team-detail">
                                 <ul>
                                    <li> <strong>Phone:</strong>  +91-98540355564</li>
                                    <li><strong>Email:</strong> gautambordoloi@gmail.com</li>
                                </ul>
                             
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mb-4">
                    <div class="row">
                        <div class="col-4">
                            <div class="team-image">
                                <img src="../assets/images/icon.png" alt="" class="img-fluid">
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="team-detail">
                                <div class="team-name text-uppercase text-info">
                                    <h5>Bhaskar B. Chetia</h5>
                                </div>
                                <span class="text-muted">Project Head</span>
                            </div>
                            <div class="team-social text-left">
                                <ul class="d-flex mt-1 text-black m-0 p-0">
                                    <li><a href="#"><i class="fab fa-facebook fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter-square fa-2x"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram fa-2x"></i></a></li>
                                </ul>
                            </div>
                            <div class="team-detail">
                                 <ul>
                                    <li> <strong>Phone:</strong>  +91-9582687166</li>
                                    <li><strong>Email:</strong>bhaskarbikram@gmail.com</li>
                                </ul>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <Footer />
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'

export default {
  components:{
    // Navigation
    // Footer
  }
}
</script>


<style scoped>

li{
    list-style: none;
}

.gallery-hero{
    position: relative;
    background-image: linear-gradient(120deg, #16161588 0%, #f7f7f700 100%), url('../assets/images/111.jpg');
    background-blend-mode: screen;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center right;
    /* object-fit:fill; */
    height: 45vh;
  }


    .hero-heading{
    font-size:108px; font-weight:700; font-family: Raleway;color: #f5f7f9; margin-bottom:-26px;letter-spacing:1rem;
}
  .about{
    font-size: var(--default-font);
    line-height: 1.9;
  }
  .pri-about-title h1{
    font-size: var(--primary-font);
  }
  .sub-about-title h2{
    font-size: var(--secondary-font);
  }
  .team-social li{
    list-style: none;
    margin-right: 10px;
  }
  .team-social a{
    text-decoration: none;
    color: #fbd020;
  }
@media (max-width: 700px){
.gallery-hero{
    height: 35vh;
    }
.hero-heading{
    font-size:6rem; font-weight:700; font-family: Raleway;color: #f5f7f9; margin-bottom:-15px;letter-spacing:.5rem;
    }
.about{
    font-size: var(--default-font);
    line-height: 1.6;
  }
}
</style>
